import type { SystemPageDto } from './system-pages.schema';
import type { Market } from '@/libs/market/market';
import z from 'zod';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { SystemPageDtoSchema } from './system-pages.schema';

export const systemPagesApi = {
  /**
   * Get system page by ID or alias
   * @param idOrAlias - ID or alias of the system page
   * @param market - storefront market used to select page content
   * @returns Promise<SystemPageDto> - system page data
   */
  async getSystemPageByIdOrAlias(idOrAlias: string, market: Market) {
    const response = await httpClient.get<SystemPageDto>(
      ENDPOINTS.systemPages.idOrAlias(idOrAlias),
      { params: { market } },
    );

    return validateWithZod(SystemPageDtoSchema, response);
  },

  async getListOfSystemPages(market: Market) {
    const response = await httpClient.get<SystemPageDto[]>(
      ENDPOINTS.systemPages.all,
      { params: { market } },
    );

    return z.array(SystemPageDtoSchema).parse(response);
  },
} as const;
